import { Organization, OrganizationUsers } from '../models/Company';
import { apiClient } from './ApiService';
import { CompanyDetailResponse } from './types/api.generated';

const getOrganizations = async (): Promise<Organization[]> => {
  try {
    return await apiClient.get<Organization[]>('/account/companies', {}, false);
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.error('Error fetching organizations:', error);
    }
    throw error;
  }
};

const createOrganization = async (owner_id: number, name: string): Promise<CompanyDetailResponse> => {
  try {
    return await apiClient.post<CompanyDetailResponse>('/account/companies/', { owner_id, name });
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.error('Error creating orgaization:', error);
    }
    throw error;
  }
};

const getUserOrganizations = async (): Promise<any> => {
  try {
    return await apiClient.get<Organization[]>('/account/user-organizations', {}, false);
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.error('Error in getUserOrganizations:', error);
    }
    throw error;
  }
};

const getOrganizationDetails = async (orgId: number): Promise<OrganizationUsers> => {
  try {
    return await apiClient.get<OrganizationUsers>(`/account/organizations/${orgId}/users-and-invitations/`, {}, false);
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.error(`Error fetching details for organization ${orgId}:`, error);
    }
    throw error;
  }
};

export const CompanyService = {
  getOrganizations,
  createOrganization,
  getUserOrganizations,
  getOrganizationDetails
};
